/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterISmall = createReactComponent("letter-i-small", "IconLetterISmall", [
  ["path", { d: "M12 8v8", key: "svg-0" }]
]);

export { IconLetterISmall as default };
//# sourceMappingURL=IconLetterISmall.js.map
